export const webDevFAQs = [
  {
    id: 1,
    question: "Wie lange dauert es, eine individuelle Website oder einen Online-Shop zu erstellen?",
    answer: "Die Entwicklungszeit hängt stark vom Funktionsumfang und Designaufwand ab. Einfache Landingpages können innerhalb von drei bis vier Wochen fertiggestellt werden. Für komplexere Portale oder Online-Shops, inklusive Benutzerverwaltung, Warenkorbfunktionen und Zahlungsanbindung, sollten Sie mit acht bis zwölf Wochen rechnen. Nach einem Erstgespräch können wir Ihnen einen genaueren Zeitplan nennen."
  },
  {
    id: 2,
    question: "Welche Technologien setzen Sie für die Webentwicklung ein?",
    answer: "Wir nutzen moderne Technologien wie HTML5, CSS3 und JavaScript-Frameworks wie React oder Vue.js für das Frontend. Für das Backend kommen Node.js, Django oder PHP-Lösungen (z.B. Laravel) zum Einsatz. Bei CMS- oder Shop-Systemen greifen wir häufig auf WordPress, WooCommerce oder Shopify zurück, je nach Bedarf und Projektumfang."
  },
  {
    id: 3,
    question: "Sind meine Seiten auch für mobile Geräte optimiert?",
    answer: "Ja. Unsere Websites und Portale werden nach dem Mobile-First-Prinzip entwickelt und sind zu 100 % responsive. Wir testen sie sorgfältig auf verschiedenen Endgeräten und Bildschirmgrößen, um eine optimale Nutzererfahrung sicherzustellen."
  },
  {
    id: 4,
    question: "Können Sie meine bestehende Website oder mein Portal modernisieren?",
    answer: "Absolut. Wir führen umfassende Redesigns durch, um veraltete Websites in zeitgemäße Plattformen zu verwandeln. Dabei achten wir besonders auf Suchmaschinenoptimierung, verbesserte Performance und ein ansprechendes UX/UI-Design, damit Ihre Nutzer gerne verweilen und interagieren."
  },
  {
    id: 5,
    question: "Was kostet eine professionelle Website oder ein Online-Shop?",
    answer: "Die Kosten variieren je nach Funktionsumfang und gewünschtem Design. Eine einfache Landingpage beginnt bei etwa 2.000–3.000 Euro. Aufwändigere Portale oder Online-Shops mit individuellen Features können zwischen 5.000 und 10.000 Euro oder mehr liegen. Nach einem kostenlosen Beratungsgespräch erhalten Sie ein passgenaues Angebot."
  },
  {
    id: 6,
    question: "Bieten Sie auch Inhalte, Bilder und Texte für meine Website an?",
    answer: "Ja. Neben der technischen Umsetzung können wir Ihnen professionelle Texter und Fotografen vermitteln. So erhalten Sie stimmige Inhalte und hochwertiges Bildmaterial, das optimal zu Ihrer Marke passt und Ihr Projekt noch ansprechender macht."
  },
  {
    id: 7,
    question: "Wie sorgen Sie für gute Suchmaschinenplatzierungen (SEO)?",
    answer: "Wir legen von Beginn an Wert auf eine saubere Code-Struktur, schnelle Ladezeiten und mobile Optimierung. Außerdem unterstützen wir Sie bei Keyword-Recherchen, Meta-Tags und anderen SEO-Maßnahmen. Auf Wunsch führen wir auch regelmäßige Analysen durch, um Ihre Positionierung stetig zu verbessern."
  },
  {
    id: 8,
    question: "Wie geht es nach dem Launch meiner Website weiter?",
    answer: "Wir lassen Sie nicht allein. Auf Wunsch bieten wir Wartungs- und Supportverträge an, damit Ihre Seite immer aktuell, sicher und performant bleibt. Dazu gehören regelmäßige Updates, Backups und Sicherheitsprüfungen. Bei Fragen oder Problemen können Sie sich jederzeit an uns wenden."
  },
  {
    id: 9,
    question: "Kann ich Inhalte später selbst verwalten und bearbeiten?",
    answer: "Ja. Wir integrieren benutzerfreundliche CMS-Lösungen wie WordPress oder Headless-CMS-Plattformen, die eine einfache Aktualisierung Ihrer Texte, Bilder und Produkte ermöglichen. Gerne schulen wir Sie und Ihr Team, damit Sie selbstständig Änderungen vornehmen können."
  },
  {
    id: 10,
    question: "Welche Sicherheitsmaßnahmen setzen Sie für meine Website oder meinen Online-Shop ein?",
    answer: "Wir verwenden SSL-Zertifikate, führen regelmäßige Sicherheitsupdates durch und überwachen Ihre Website auf mögliche Schwachstellen. Gerade bei Online-Shops legen wir großen Wert auf sichere Zahlungsmethoden, Datenschutz und die Einhaltung von Richtlinien wie DSGVO."
  }
];

export const webDevIntro = {
  title: "Webentwicklung FAQs",
  subtitle: "Häufig gestellte Fragen & Antworten",
  description: "Hier finden Sie Antworten zu wichtigen Themen rund um Webportale, Online-Shops und Landingpages. Falls Sie Ihre Frage hier nicht entdecken, kontaktieren Sie uns gerne direkt für eine individuelle Beratung."
};
